import React from 'react';
import Helmet from 'react-helmet';
import { injectIntl } from 'react-intl';

import DiLayout from './DiLayout';
import DiLoading from './DiLoading';

const DiLoadingPage = ({ intl, size = 'sm' }) => {
  const title = intl.formatMessage({
    id: 'DiLayout.DiLoadingPage.title',
    defaultMessage: 'Loading…',
  });
  return (
    <DiLayout size={size}>
      <Helmet>
        <title>{title}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <DiLoading />
    </DiLayout>
  );
};

export default injectIntl(DiLoadingPage);
